import React from 'react'
import './index.css'
import useSelector from 'hooks/use-selector'
import getSizeGuideLabelGiftSelect from 'modules/product/redux/selectors/get-size-guide-label'
import Span from 'components/Span'
import Flex from 'components/Flex'
import TextSemiBold from 'components/TextSemiBold'
import VerticalSeparator from 'components/VerticalSeparator'
import splitStringWithParenthesisIntoTwoLinesStringUtil from 'utils/string/split-string-in-two-lines'
import View from 'components/View'
import InfoIcon from 'components/Icons/InfoIcon'
import removeParenthesisStringUtil from 'utils/string/remove-parenthesis'
import capitalizeStringUtil from 'utils/string/capitalize'
import getSizeGuideProductVariantUtil from 'modules/product-variant/utils/get-size-guide'
import shouldHideVariantButtonsSelector from 'containers/QuickShopProductSidebar/components/VariantButtons/selectors/should-hide-variant-buttons'

// const SIZE_GUIDE = 'Size guide'

const LABEL = 'Size'

/**
 * @param props
 * @param props.productVariant
 * @param props.hasVariantButtons
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarSizeGuide (props) {
  const {
    productVariant,
    hasVariantButtons
  } = props

  const hideBothFullSizeAndSampleButtons = useSelector(shouldHideVariantButtonsSelector)

  const sizeLabel = (
    useSelector(getSizeGuideLabelGiftSelect) ??
    getSizeGuideProductVariantUtil({ productVariant })
  )
  const sizeLabelArr = splitStringWithParenthesisIntoTwoLinesStringUtil(sizeLabel)

  const debugProps = {
    hideBothFullSizeAndSampleButtons,
    props,
    sizeLabelArr
  }

  logUtil('QuickShopProductSidebarSizeGuide').debug('debugProps=', debugProps)
  const value = sizeLabelArr[0]

  if (!value) {
    return <></>
  }

  return (
    <View>
      <Flex className='quick-shop-product-sidebar-size-guide-title'>
        <TextSemiBold className='quick-shop-product-sidebar-size-guide-title-label'>
          {LABEL}
        </TextSemiBold>

        <VerticalSeparator />

        <Span className='quick-shop-product-sidebar-size-guide-title-value'>
          {value}
        </Span>

      </Flex>

      {
        (
          !hasVariantButtons ||
          hideBothFullSizeAndSampleButtons
        ) &&
        !!sizeLabelArr[1] && (
          <Flex className='quick-shop-product-sidebar-size-guide-title-value-more-info'>
            <InfoIcon />
            <Span>
              {
                capitalizeStringUtil(
                  removeParenthesisStringUtil(sizeLabelArr[1])
                )
              }
            </Span>
          </Flex>
        )
      }
    </View>
  )
}
